/**
 * SECTION — GLOBAL NUMBERED COLUMNS
 *
 * Adds `.in` to the section when it scrolls into view, which triggers the
 * staggered column reveal + gold-bar draw. Progressive enhancement: without JS
 * the columns and bars are already visible (html.no-js in the CSS).
 */
(function () {
  'use strict';

  function init() {
    var sections = document.querySelectorAll('[data-numbered-columns]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('in'); });
      return;
    }

    sections.forEach(function (section) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('in');
            io.disconnect();
          }
        });
      }, { threshold: 0.2 });
      io.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
